module.exports = __webpack_public_path__ + "static/media/noCard.4c02c80b.svg";